import { RequestMiddleware } from "./RequestUtil";

export function LoadingMiddleware(
  onChange?: (loading: boolean) => void
): RequestMiddleware {
  return {
    preRequest() {
      onChange(true);
    },
    postRequest() {
      onChange(false);
    },
    onError(error) {
      onChange(false);
    }
  };
}
